import React, { useState, useContext, useEffect } from 'react';
import { Link } from "react-router-dom";
import './Profile.css';

import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext'

import LeftColumn from '../MainPage/LeftColumn/LeftColumn';
import PersonalDataBlock from './PersonalDataBlock/PersonalDataBlock';
import AvatarMenu from './AvatarMenu/AvatarMenu';
import FullScreenImage from '../App/Common/FullScreenImage/FullScreenImage';
import FileInput from './FileInput/FileInput';
import Calendar from '../Calendar/Calendar';

const Profile = ({ courses }) => {
    const [tab, setTab] = useState(false)
    const [titleTag, setTitle] = useState('_courses')
    const { setCurrentPlace } = useContext(JourneyContext)
    const { user } = useContext(CurrentUserContext);
// console.log(user)
    const [avatar, setAvatar] = useState(user?.avatar ? user.avatar : undefined)
    const [isPersonalDataOpened, setIsPersonalDataOpened] = useState(false)
    const [isAvatarMenuOpened, setIsAvatarMenuOpened] = useState(false)
    const [isPhotoOpened, setIsPhotoOpened] = useState(false)
    const [isInputOpened, setIsInputOpened] = useState(false)


    
    useEffect(() => {
        
       setAvatar(user?.avatar)
      }, [user]);

      useEffect(() => {
        setCurrentPlace({title: 'Профиль'})
       }, []);

       const handleOpenTab = (title) => {
        if (title === 'Все курсы') {
            setTab(false)
            setTitle('_courses')
        } else if (title === 'Календарь') {
            setTab(true)
            setTitle('_calendar') 
        }
      }

    return (
       user && <div className='profile__wrapper'> <div className='profile__container'>
            {/* <LeftColumn courses={courses}/> */}
            <div className='tab__wrap'>
                    <div className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')} onClick={() => handleOpenTab('Все курсы')}>Профиль</div>
                    {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
                </div>
               <div>
               {tab && titleTag ==='_calendar' && <div className='courses__calendar'><Calendar></Calendar></div>}

            {!tab && <div className='profile__center'>
                {/* <div className='performance__navTree'>
                   <Link to={'/'}> <div >Главная</div></Link>
                    <div className='current'>Профиль</div>
                </div> */}
               
              
                <div className='profile__main ' style={{height: isPersonalDataOpened? '100%' : ''}}>
                <div className='profile__mainInfo courses__calendar'>
                   
                        {avatar ?
                            <img className='profile__image' src={avatar} alt='avatar' onClick={() => { setIsAvatarMenuOpened(!isAvatarMenuOpened) }} />
                            :
                            <div className='profile__image defaultAvatar' onClick={() => { setIsAvatarMenuOpened(!isAvatarMenuOpened) }}></div>

                        }
                        {isInputOpened && 
                        <FileInput setAvatar={setAvatar} setIsInputOpened={setIsInputOpened} />
                        }
                        {isAvatarMenuOpened &&
                            <AvatarMenu openPhoto={setIsPhotoOpened} onClose={setIsAvatarMenuOpened} changePhoto={setIsInputOpened}  setAvatar={setAvatar} />
                        }
                       {/* <div className='profile__wrapInfo'> */}
                       <div className='profile__userInfo_block'>
                        <p className='profile__name'>{`${user.name ? user.name : 'Макарова Кристина Викторовна'}`}</p>
                        <div className='personalData__infoContainer'>
                                <PersonalDataBlock capture={'Дата рождения'} data={user.date_of_birth} />
                                <PersonalDataBlock capture={'Телефон'} data={user.phone} />
                                <PersonalDataBlock capture={'Почта'} data={user.mail} />
                            </div>
                       </div>
                        <div className='personalData__container'>
                            {/* <div className='personalData__me'> */}
                            {/* <div className='personalData__title'>Мои данные</div> */}
                            
                            <div className='personalData__title'>Ответственные</div>
                            <div className='personalData__infoContainer'>
                                <PersonalDataBlock capture={'ФИО'} data={user.responsible_1.full_name} />
                                <PersonalDataBlock capture={'Телефон'} data={user.responsible_1.phone} />
                                <PersonalDataBlock capture={'Почта'} data={user.responsible_1.mail} />
                            </div>
                        {user.responsible_2 && <div className='personalData__infoContainer'>
                                <PersonalDataBlock capture={'ФИО'} data={user.responsible_2.full_name} />
                                <PersonalDataBlock capture={'Телефон'} data={user.responsible_2.phone} />
                                <PersonalDataBlock capture={'Почта'} data={user.responsible_2.mail} />
                            </div>}
                            {/* </div> */}
                        </div>
                       {/* </div> */}
                    </div>
                    {/* <div className='profile__personalData' onClick={() => setIsPersonalDataOpened(!isPersonalDataOpened)}><div className={`profile__arrow ${isPersonalDataOpened ? 'rotated' : ''}`} />Личные данные</div> */}
                    {/* {isPersonalDataOpened && */}
                    

                    {/* } */}
                    {/* <textarea style={{ width: '80%', height: '50px', flexShrink: 0, margin: '24px'}}></textarea> */}
                </div>
            </div>}
            {isPhotoOpened &&
                <FullScreenImage image={user.avatar} onClose={setIsPhotoOpened} />
            }
            </div>
        </div>
        </div>
    )
}
export default Profile
